module.exports = __webpack_public_path__ + "img/noble-container-bg.e8635d6a.png";